<template><div><h1 id="einzelbuchung" tabindex="-1"><a class="header-anchor" href="#einzelbuchung"><span>Einzelbuchung</span></a></h1>
<p>Einzelbuchung — Elementare Buchhaltungsstruktur der Buchhaltung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Einzelbuchungen werden aus den offenen Posten generiert und können nicht manuell erfasst werden. Diese wiederum werden aggregiert zu Sammelbuchungen.</p>
<p>Pfad: <code v-pre>Buchhaltung → Einzelbuchungen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>JourNr:</dt>
<dd>Journalnummer</dd>
<dt>BelNr:</dt>
<dd>Belegnummer</dd>
<dt>ValDat:</dt>
<dd>Valuta Datum, entspricht dem Erfassungsdatum</dd>
<dt>Soll/Sollkonto:</dt>
<dd>Sollkonto</dd>
<dt>Kst:</dt>
<dd>Kostenstelle</dd>
<dt>AdrNr:</dt>
<dd>Personen-ID</dd>
<dt>T/Typ:</dt>
<dd>Buchungstyp</dd>
<dt>BetragLW:</dt>
<dd>Betrag in Landeswährung</dd>
<dt>BetragFW:</dt>
<dd>Betrag in Fremdwährung</dd>
<dt>Mandant:</dt>
<dd>Mandant</dd>
<dt>Haben/Habenkonto:</dt>
<dd>Habenkonto</dd>
<dt>Ktr:</dt>
<dd>Kostenträger</dd>
<dt>FakNr:</dt>
<dd>Fakturanummer</dd>
<dt>Kurs:</dt>
<dd>Wechselkurs der Fremdwährung</dd>
<dt>MWST:</dt>
<dd>Mehrwertsteuer-Code</dd>
<dt>AufNr:</dt>
<dd>Auftragsnummer und Auftragspositionnummer</dd>
<dt>S/Status:</dt>
<dd>Status der Einzelbuchung. Folgende Stati sind möglich:
<table>
<thead>
<tr>
<th>Status</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>0</td>
<td>K / KS-Einzelbuchungen mit Betrag &gt; 0</td>
</tr>
<tr>
<td>1</td>
<td>alle übrigen Einzelbuchungen</td>
</tr>
</tbody>
</table>
</dd>
<dt>Whg:</dt>
<dd>Währung</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="eb-kontoauszuge" tabindex="-1"><a class="header-anchor" href="#eb-kontoauszuge"><span>EB-Kontoauszüge</span></a></h3>
<p>Anzeigen von vordefinierten und kundenspezifischen Auswertungen. Siehe im Detail <RouteLink to="/referenz/refstat/ft.refstat.deb.html" title="Auswertungen Buchhaltung">Statistiken Debitorenverwaltung</RouteLink></p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/buchhaltung/debitorenverwaltung.html#Debitorenverwaltung" title="1. Debitorenverwaltung">Debitorenverwaltung</RouteLink></p>
</div></template>


